import { render, staticRenderFns } from "./UserChecklists.vue?vue&type=template&id=880406a2&"
import script from "./UserChecklists.vue?vue&type=script&lang=js&"
export * from "./UserChecklists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports